export const alsoHereUpdatePresenceTimeout = 50_000
